module.exports = __webpack_public_path__ + "static/media/icomoon.91b9c5ea.ttf";